<template>
    <v-dialog v-model="dialog" fullscreen :scrim="false" transition="dialog-bottom-transition">
        <v-card class="d-flex flex-column">
            <v-toolbar dark color="primary" class="flex-grow-0">
                <v-btn icon="mdi-close" variant="text" @click="dialog = false" />
                <v-toolbar-title>{{ $t('email_form.text') }}</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                    <v-btn variant="text" @click="save">{{ $t('save') }}</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <div class="d-flex flex-grow-1 wrapper">
                <email-editor ref="editor" class="flex-grow-1" @load="editorLoaded" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import {EmailEditor} from 'vue-email-editor'

    @Component({
        components: {
            EmailEditor,
        },
    })
    export class EmailEditModal extends Vue {
        @VModel() dialog
        @Prop({required: true}) json

        design = null

        @Emit()
        change(html) {
            return html
        }

        save() {
            this.$refs.editor.exportHtml(({html, design}) => {
                this.design = design
                this.dialog = false
                this.change(html)
            })
        }

        editorLoaded() {
            this.$refs.editor.loadDesign(this.design || JSON.parse(this.json))
        }
    }

    export default EmailEditModal
</script>

<style scoped lang="scss">
    .wrapper {
        line-height: 0;
    }
</style>
